import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import NavbarLeft from "./../Components/NavbarLeft";
import { ReactComponent as QuestionMark } from "../../assets/navbar/QuestionMark.svg";
import { ReactComponent as BackArrow } from "../../assets/navbar/BackArrow.svg";
import { ReactComponent as HEcoC } from "../../assets/ecoscore/eco_h_c.svg";
import { ReactComponent as Plus } from "../../assets/analyse/Plus.svg";
import ScoreCircle from "../Components/ScoreCircle";
import "react-widgets/styles.css";
import "react-toastify/dist/ReactToastify.css";
// import data from "../../app_data/ref_analysis/5b58909c-3a2f-47f8-bb65-c13b8b9aa4e5.json";
// REDUX
import { useDispatch, useSelector, shallowEqual, connect } from "react-redux";
import { fetchImpactIndicators } from "../../redux/actions/analysisActions";
import { fetchOptimization } from "../../redux/actions/optimizationActions";

import ColumnDescrition from "./../Components/ColumnDescrition";
import ColumsTop from "../Components/ColumsTop";
import ColumnMenu from "../Components/ColumnMenu";

import ComponentLoading from "../../commonComponents/ComponentLoading";
import { get_eco_score_icon, calculImpactStepResultOpt } from "../../utils/utils.js";

import ref_data from "../../app_data/ref_reduction/optimization_2.json";
import ReduceStep from "./../Components/ReduceStep";
import ReduceStepRight from "../Components/ReduceStepRight";
import EcoScoreIndicatorsMenu from "../Components/EcoScoreIndicatorsMenu";

const ReduceAnalysis = () => {
  //  const location = useLocation();
  const [description, setDescription] = useState(0);
  const [savePopUp, setSavePopUp] = useState("");
  const [columnMenu, setColumnMenu] = useState("");
  const [columns, setColumns] = useState(["da32f256-618d-4bec-a8d9-205817788b26", "801c90a5-5b8d-312e-a924-ad9a275c754a"]);

  const dispatch = useDispatch();

  const fetchImpactIndicators_rd = () => dispatch(fetchImpactIndicators());
  const fetchOptimization_rd = (item) => dispatch(fetchOptimization(item));
  const impact_indicators = useSelector((state) => (state.analysis.impact_indicators ? state.analysis.impact_indicators : null));

  useEffect(() => {
    const fetchImpactIndicators_fn = async () => {
      await fetchImpactIndicators_rd();
    };
    if (!impact_indicators) {
      fetchImpactIndicators_fn();
    }
  }, []);

  const [ecoScoreIndicatorsMenu, setEcoScoreIndicatorsMenu] = useState(false);

  // REDUX ACTIONS
  //  const dispatch = useDispatch();
  //  const fetchAnalysis_rd = (item) => dispatch(fetchAnalysis(item));
  // REDUX STATES
  const analysis_id = useSelector((state) => (state.optimization.analysis_id ? state.optimization.analysis_id : null));
  const analysis_data = ref_data.data.optimization_output;

  // console.log('HISTOOOOO: ', location.state.history)
  // const optmization_id = "b5b6b50ba68c-49aa-857c-4f2b209b8740";
  const optimization_data = useSelector((state) => state.optimization.optimization_data, shallowEqual);
  // GET ANALYSIS DATA
  useEffect(() => {
    const fetchData = async () => {
      await fetchOptimization_rd(analysis_id);
    };
    // if (location.state && !location.state.history) {
    //   fetchData()
    // }
    // if (location.state == null) {
    fetchData();
    // }
  }, []);

  

  // SET TOTAL SCORE
  const [totalScore, setTotalScore] = useState(null);

  useEffect(() => {
    const calc_fn = async () => {
      const eco_s = await calculImpactStepResultOpt(optimization_data, "da32f256-618d-4bec-a8d9-205817788b26", 6);
      console.log("total ", eco_s);
      setTotalScore(eco_s);
    };
    if (optimization_data) {
      calc_fn();
    }
  }, [optimization_data]);

  const [hidden, setHidden] = useState([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]);

  return (
    <>
      {/* {analysis_data && totalScore ? */}
      {optimization_data && impact_indicators && totalScore ? (
        <>
          {description !== 0 ? <ColumnDescrition description={description} setDescription={setDescription} columns={columns} setColumns={setColumns} /> : null}
          {savePopUp ? (
            <div className="fixed w-full h-full bg-black/20 flex justify-center items-center z-30">
              <div className="bg-white w-[650px] h-[375px] rounded-xl relative z-10">
                <div className="w-[400px] ml-[75px] mt-[50px] text">
                  <p className="font-Poppins-SemiBold text-4xl">Renseignez la référence du produit</p>
                  <p className="font-Poppins-Light text-gray-500 mt-[30px] text-sm">vous pouvez modifier ceci plus tard</p>
                </div>
                <div className="h-[70px] w-full flex justify-center items-end">
                  <input className="bg-gray-100 w-[500px] h-[30px] rounded-lg pl-[50px] font-Poppins-Light text-sm" placeholder="nom du produit" />
                </div>
                <div className="h-[80px] w-full flex items-end justify-center">
                  <button
                    className="bg-mainGreen w-[135px] h-[35px] rounded-lg text-white font-Poppins-SemiBold text-sm"
                    onClick={() => {
                      setSavePopUp(0);
                    }}
                  >
                    Valider
                  </button>
                </div>
              </div>
            </div>
          ) : null}

          {columnMenu ? <ColumnMenu columns={columns} setColumnMenu={setColumnMenu} setColumns={setColumns} /> : null}

          <NavbarLeft currentPage={3} className="relative z-50" />

          {/* LEGEND */}
          <div className="fixed w-max h-[60px] bottom-[40px] left-[400px] flex justify-center items-end z-50">
            <div className="bg-white shadow-xl rounded-xl relative z-50 flex justify-center h-[40px] w-[650px]">
              <div className="w-[540px] h-[40px] flex justify-center items-center">
                <div className="flex justify-start items-center h-[30px] w-[180px]">
                  <div className="bg-white border-[1px] border-mainGreen rounded-full w-[20px] h-[20px] ml-[10px]" />
                  <p className="ml-[20px] font-Poppins-Regular text-xs">Modifié par vous</p>
                </div>
                {/* <div className="flex justify-start items-center h-[30px] w-[180px]">
                  <div className="bg-yellow-400/25 rounded-full w-[20px] h-[20px] ml-[10px]" />
                  <p className="ml-[20px] font-Poppins-Regular text-xs">Modifié par vous</p>
                </div> */}
                <div className="flex justify-start items-center h-[30px] w-[180px]">
                  <div className="bg-green-500/25 rounded-full w-[20px] h-[20px] ml-[10px]" />
                  <p className="ml-[20px] font-Poppins-Regular text-xs">Proposé par Lokalité</p>
                </div>
              </div>
            </div>
          </div>

          <div className=" w-full fixed h-[70px] bg-white flex items-center border-[#BEC4CA] justify-evenly z-40">
            <div className="flex ml-16">
              <Link to="/Reduce">
                <BackArrow />
              </Link>
            </div>

            <div className="ml-10 flex items-center  justify-between">
              <div className="h-[50px] w-60 flex items-center">
                <p className="font-Poppins-SemiBold inline overflow-hidden text-ellipsis">{"Analyser - " + optimization_data.lca.lca_steps[0].ciqual_name.fr}</p>
              </div>
              <div className="flex items-center">
                {/* {get_eco_score_icon(parseFloat(optimization_data.eco_score))} */}
                {get_eco_score_icon(optimization_data.eco_score)}
                <div className="h-[60px] w-[60px]">
                  <ScoreCircle score={optimization_data.eco_score} />
                  {/* <ScoreCircle score={85} /> */}
                </div>
              </div>
            </div>

            <div className="flex">
              {/* <MagnifiyingGlass fill='#169A6A'/> */}
              {/* <input className="w-[600px] mx-10 rounded-md bg-[#F8FAFB] font-PoppinsLignt text-sm h-[35px]" type="text" placeholder="recherche un produit, un procédé, une étape..." /> */}
              <div className="w-[600px] mx-10 rounded-md bg-white font-PoppinsLignt text-sm h-[35px]" />
            </div>

            {/* <UndoRedo is_reduce={true} /> */}
            <div>
              <div className="h-[40px] w-[130px] flex justify-center" />
            </div>
          </div>

          <div className="ml-[50px] mt-[70px] w-max">
            <div className="h-[95px] flex justify-start ml-[20px]">
              <div>
                <div className="h-[95px] flex items-center w-[563px]">
                  <div onClick={() => setEcoScoreIndicatorsMenu(true)} className="flex items-center justify-center bg-[#7E84A3] p-[10px] rounded-lg ml-[40px]">
                    <Plus height={20} fill={"white"} />
                    <p className="font-Poppins-SemiBold text-sm text-white pr-[4px]">Indicateurs spécifiques pour l'éco-score</p>
                  </div>
                </div>

                {ecoScoreIndicatorsMenu && <EcoScoreIndicatorsMenu setEcoScoreIndicatorsMenu={setEcoScoreIndicatorsMenu} is_reduce={true} />}

                <div>
                  {/* <p
                    onClick={() => {
                      console.log("totalScore", totalScore);
                    }}
                  >
                    REDUCE_ANALYSIS
                  </p> */}

                  <ReduceStep
                    hidden={hidden}
                    setHidden={setHidden}
                    width={600}
                    columns={columns}
                    name={"Recettes"}
                    icon={"Recette"}
                    size={optimization_data.lca.lca_steps[4].inputs.length}
                    data={optimization_data ? optimization_data.lca.lca_steps[4] : null}
                    ingredients={optimization_data.ingredients ? optimization_data.ingredients : null}
                    totalScore={totalScore}
                    depth={0}
                  />
                  <ReduceStep
                    hidden={hidden}
                    setHidden={setHidden}
                    width={600}
                    columns={columns}
                    name={"Packaging"}
                    icon={"Packaging"}
                    size={optimization_data.lca.lca_steps[3].inputs.length}
                    data={optimization_data.lca.lca_steps[3]}
                    totalScore={totalScore}
                    depth={0}
                  />
                  <ReduceStep
                    hidden={hidden}
                    setHidden={setHidden}
                    width={600}
                    columns={columns}
                    name={"Distribution"}
                    icon={"Distribution"}
                    size={optimization_data.lca.lca_steps[2].length}
                    data={optimization_data.lca.lca_steps[2]}
                    totalScore={totalScore}
                    depth={0}
                  />
                  <ReduceStep
                    hidden={hidden}
                    setHidden={setHidden}
                    width={600}
                    columns={columns}
                    name={"Vente au détail"}
                    icon={"Vente au détail"}
                    size={optimization_data.lca.lca_steps[1].length}
                    data={optimization_data.lca.lca_steps[1]}
                    totalScore={totalScore}
                    depth={0}
                  />
                  <ReduceStep
                    hidden={hidden}
                    setHidden={setHidden}
                    width={600}
                    columns={columns}
                    name={"Consommation"}
                    icon={"Consommation"}
                    size={optimization_data.lca.lca_steps[0].length}
                    data={optimization_data.lca.lca_steps[0]}
                    totalScore={totalScore}
                    depth={0}
                  />
                </div>
              </div>

              {/* SCROLL RIGHT */}

              <div className=" overflow-scroll w-[767px] h-max">
                <div className="h-[95px] w-max flex border-y-[1px] border-t-[1px] boder-[#BEC4CA] bg-white">
                  <ColumsTop columns={columns} setDescription={setDescription} />
                </div>

                <div className="flex">
                  <div>
                    <ReduceStepRight
                      hidden={hidden}
                      width={600}
                      columns={columns}
                      name={"Recettes"}
                      icon={"Recette"}
                      size={optimization_data.lca.lca_steps[4].inputs.length}
                      data={optimization_data ? optimization_data.lca.lca_steps[4] : null}
                      ingredients={optimization_data.ingredients ? optimization_data.ingredients : null}
                      totalScore={totalScore}
                      depth={0}
                    />
                    <ReduceStepRight
                      hidden={hidden}
                      width={600}
                      columns={columns}
                      name={"Packaging"}
                      icon={"Packaging"}
                      size={optimization_data.lca.lca_steps[3].inputs.length}
                      data={optimization_data.lca.lca_steps[3]}
                      totalScore={totalScore}
                      depth={0}
                    />
                    <ReduceStepRight
                      hidden={hidden}
                      width={600}
                      columns={columns}
                      name={"Distribution"}
                      icon={"Distribution"}
                      size={optimization_data.lca.lca_steps[2].length}
                      data={optimization_data.lca.lca_steps[2]}
                      totalScore={totalScore}
                      depth={0}
                    />
                    <ReduceStepRight
                      hidden={hidden}
                      width={600}
                      columns={columns}
                      name={"Vente au détail"}
                      icon={"Vente au détail"}
                      size={optimization_data.lca.lca_steps[1].length}
                      data={optimization_data.lca.lca_steps[1]}
                      totalScore={totalScore}
                      depth={0}
                    />
                    <ReduceStepRight
                      hidden={hidden}
                      width={600}
                      columns={columns}
                      name={"Consommation"}
                      icon={"Consommation"}
                      size={optimization_data.lca.lca_steps[0].length}
                      data={optimization_data.lca.lca_steps[0]}
                      totalScore={totalScore}
                      depth={0}
                    />
                  </div>
                  <div className={`w-[100px] px-[20px] h-screen bg-[#F3F5F7] flex justify-center items-center`}>
                    <button
                      onClick={() => {
                        setColumnMenu(1);
                      }}
                    >
                      <Plus />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full h-[50px]" />
          </div>
        </>
      ) : (
        <>
        <p onClick={() => {
          console.log(impact_indicators, totalScore, optimization_data, analysis_id)
        }}>DEBUGDEBUGDEBUGDEBUGDEBUGDEBUGDEBUGDEBUGDEBUGDEBUGDEBUGDEBUGDEBUGDEBUGDEBUG</p>
          <ComponentLoading height={35} style={"h-full flex items-center justify-center"} />
        </>
      )}
    </>
  );
};

export default ReduceAnalysis;
